import { useEffect } from "react";
import { useSchoolyear } from "./useSchoolyear";

interface SchoolyearActiveStatus {
  isSchoolyearActive: boolean;
  isCheckingSchoolyearActive: boolean;
}

export const useSchoolyearActive = (): SchoolyearActiveStatus => {
  const {
    activeSchoolyearSignature,
    fetchActiveSchoolyearSignature,
    loading: isFetchingSchoolyearSignature,
  } = useSchoolyear();

  // If we have an active SY signature, we can conclude SY is active
  const isSchoolyearActive = !!activeSchoolyearSignature;
  const isSchoolyearStatusUnknown = activeSchoolyearSignature === null;
  const isCheckingSchoolyearActive = isSchoolyearStatusUnknown && isFetchingSchoolyearSignature;

  // Attempt to fetch schoolyear signature to verify if user is currently using Schoolyear app
  useEffect(() => {
    if (isSchoolyearStatusUnknown && !isFetchingSchoolyearSignature) {
      fetchActiveSchoolyearSignature();
    }
  }, [fetchActiveSchoolyearSignature, isSchoolyearStatusUnknown, isFetchingSchoolyearSignature]);

  return {
    isSchoolyearActive,
    isCheckingSchoolyearActive,
  };
};
